<form [formGroup]="frmJoin">
    <div class="w-full">
        <label class="mb-3">Invia un messaggio di presentazione*</label>
        <textarea rows="5" pInputTextarea class="w-full mt-1" formControlName="message"></textarea>
        @if(frmJoin.get('message')?.errors && frmJoin.get('message')?.dirty){
            <st-errors [errors]="frmJoin.get('message')?.errors"></st-errors>
            }
    </div>
</form>


<div class="modal-footer flex justify-content-between">
    <div class="w-full">
        <p-button label="Annulla" size="small" (click)="close()" [outlined]="true"></p-button>
    </div>
    <div class="w-full ml-3">
        <p-button label="Invia" size="small" (click)="save()" styleClass="slide-o" [disabled]="frmJoin.invalid"></p-button>
    </div>
</div>
